<button type="button" onclick="this.blur()" (click)="clear.emit()" mat-raised-button>
    <mat-icon>close</mat-icon>
    {{ 'common.clearFilters' | translate }}
</button>